import React from "react";
import { Popover } from "react-tiny-popover";
import MaskedInput from "react-text-mask";
import cn from "classnames";
import { parse } from "date-fns/parse";

import DropdownIcon from "assets/icons/dropdown-icon.svg?react";

import { DATE_PIPE, MASK } from "./DatePickerInput.constants";

import { Input } from "shared/ui/components/Input";
import { DayPicker } from "shared/ui/components/DayPicker";

import styles from "./DatePickerInput.module.scss";

interface CustomComponentProps {
  onClick: () => void;
  children: React.ReactNode;
}

const CustomComponent = React.forwardRef<HTMLDivElement, CustomComponentProps>(
  (props, ref) => (
    <div ref={ref} onClick={props.onClick}>
      {props.children}
    </div>
  )
);

const DatePickerInput = ({
  popoverOpen,
  DEFAULT_DATE_FORMAT,
  inputRef,
  value,
  defaultMonth,
  onDaySelect,
  onCalendarIconClick,
  ...restProps
}) => (
  <MaskedInput
    {...restProps}
    keepCharPositions
    pipe={DATE_PIPE}
    mask={MASK}
    guide={false}
    placeholderChar=" "
    value={value}
    render={(ref, props) => (
      <Input
        {...props}
        inputRef={(element) => {
          ref(element);

          if (inputRef) {
            inputRef.current = element;
          }
        }}
      />
    )}
    endAdornmentClassName={styles.endAdornment}
    endAdornment={
      <Popover
        isOpen={popoverOpen}
        onClickOutside={() => onCalendarIconClick()}
        containerStyle={{
          zIndex: "900",
          border: "1px solid rgba(8, 8, 8, 0.1)",
          borderRadius: "8px",
          padding: "4px",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
        }}
        transform={{ top: 16, left: 10 }}
        transformMode="relative"
        positions={["bottom"]}
        align="end"
        content={
          <DayPicker
            {...restProps}
            value={value ? parse(value, DEFAULT_DATE_FORMAT, new Date()) : null}
            onChange={onDaySelect}
          />
        }
      >
        <CustomComponent onClick={() => onCalendarIconClick()}>
          <DropdownIcon
            className={cn(styles.icon, { [styles.iconActive]: popoverOpen })}
            name="calendar"
            onClick={onCalendarIconClick}
          />
        </CustomComponent>
      </Popover>
    }
  />
);

export default DatePickerInput;
